// src/pages/Dashboard/teacher/paperEvaluation/PaperEvaluationSection.jsx
import React from "react";
import { useTranslation } from "react-i18next";
import PaperEvaluationQuestion from "./PaperEvaluationQuestion";

const PaperEvaluationSection = ({
  section,
  sectionIndex,
  studentId,
  uploadProgress,
  evaluationResults,
  onAddQuestion,
  onRemoveQuestion,
  onFileSelect,
  onRemoveFile,
  onOpenVerifyModal,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white rounded-xl shadow-md p-6 mb-6 border border-gray-100">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-gray-900">
          {section.section_type === "SAQ"
            ? t("paperEval.saqTitle")
            : t("paperEval.laqTitle")}
        </h2>

        <span className="text-xs px-2 py-1 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-100">
          {section.questions.length}{" "}
          {section.questions.length === 1
            ? t("paperEval.questionSingular")
            : t("paperEval.questionPlural")}
        </span>
      </div>

      {section.questions.map((question, questionIndex) => {
        const evalKey = `${section.section_type}_${question.question_id}`;
        const evaluationResult = evaluationResults[evalKey];

        const readyForGrading =
          question.files.length > 0 &&
          question.files.every((_, fileIndex) => {
            const key = `${studentId}_${section.section_type}_${question.question_id}_${fileIndex}`;
            return uploadProgress[key]?.status === "ocr_complete";
          });

        return (
          <PaperEvaluationQuestion
            key={questionIndex}
            section={section}
            question={question}
            sectionIndex={sectionIndex}
            questionIndex={questionIndex}
            studentId={studentId}
            uploadProgress={uploadProgress}
            onFileSelect={onFileSelect}
            onRemoveFile={onRemoveFile}
            onRemoveQuestion={onRemoveQuestion}
            onOpenVerifyModal={onOpenVerifyModal}
            readyForGrading={readyForGrading}
            evaluationResult={evaluationResult}
          />
        );
      })}

      <button
        onClick={() => onAddQuestion(sectionIndex)}
        className="text-blue-600 hover:text-blue-800 text-sm font-medium flex items-center gap-1"
      >
        <span className="text-lg">+</span> {t("paperEval.addQuestion")}
      </button>
    </div>
  );
};

export default PaperEvaluationSection;
